/**
 * Nav labels are stored as a single comma-separated string on `Data.label`
 * (e.g. "Semester 2,new"), so one topic can carry multiple tags. Placement is
 * driven by each token's value: tokens matching "semester" render on their own
 * line above the topic name; "new" renders inline at the end of the row.
 */

export const parseLabelTokens = (label?: string): string[] =>
  (label ?? '')
    .split(',')
    .map((token) => token.trim())
    .filter(Boolean);

export const getSemesterLabels = (label?: string): string[] =>
  parseLabelTokens(label).filter((token) => /semester/i.test(token));

export const hasNewLabel = (label?: string): boolean =>
  parseLabelTokens(label).some((token) => token.toLowerCase() === 'new');
